import { compressImage } from '@home/utils/image';

/**
 * @description 截图方法（使用 modern-screenshot 库，支持 mask-image 等现代 CSS 特性）
 * @date 2025-01-24
 * @author lv.chen
 * @param target 目标元素
 * @param fileName 文件名
 * @returns File 对象
 */
export const screenshot = async (target: HTMLElement, fileName: string) => {
  if (!target) {
    return;
  }

  console.debug('[Screenshot] 开始截图，使用 modern-screenshot 库');

  try {
    const { domToPng } = await import(/* webpackChunkName: "modern-screenshot" */ 'modern-screenshot');
    // 使用 modern-screenshot 的 domToPng 方法
    // modern-screenshot 对现代 CSS 特性（包括 mask-image）有更好的支持
    const dataUrl = await domToPng(target, {
      scale: 2,
      // 设置质量
      quality: 1,
      // 启用调试模式
      debug: false,
    });

    console.debug('[Screenshot] 截图完成，转换为 File 对象');

    // 将 dataUrl 转换为 Blob
    const response = await fetch(dataUrl);
    const blob = await response.blob();

    // 创建 File 对象
    let file = new File([blob], fileName, {
      type: 'image/png',
      lastModified: Date.now(),
    });

    // 如果文件大于 2MB，进行压缩
    if (file.size > 2 * 1024 * 1024) {
      console.debug(`[Screenshot] 文件大小 ${Math.round(file.size / 1024)}KB，开始压缩`);
      const compressResult = await compressImage(file, { quality: 0 });
      file = compressResult.file;
      console.debug(`[Screenshot] 压缩后大小 ${Math.round(file.size / 1024)}KB`);
    }

    return file;
  } catch (error) {
    console.error('[Screenshot] 截图失败:', error);
    throw error;
  }
};
